import { render } from "./AiGenerationTabs.vue?vue&type=template&id=75a021d6&scoped=true"
import script from "./AiGenerationTabs.vue?vue&type=script&lang=js"
export * from "./AiGenerationTabs.vue?vue&type=script&lang=js"

import "./AiGenerationTabs.vue?vue&type=style&index=0&id=75a021d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a021d6"]])

export default __exports__